
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17 12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"16","height":"12","fill":"#323334","rx":"2"}}),_c('path',{attrs:{"fill":"#FFF","fill-rule":"nonzero","d":"M3.8 7.9H2.4L2.1 9h-1l1.5-5.3h1L5.1 9h-1l-.3-1.1zM2.6 7h1L3 5.1l-.5 2zm3.9 2V3.7H8c.6 0 1 0 1.3.3.3.3.5.6.5 1.1 0 .3 0 .5-.2.7a1 1 0 01-.5.4c.3.1.5.3.6.5.2.2.2.4.2.7 0 .6-.1 1-.4 1.2-.3.3-.7.4-1.2.4H6.5zm1-2.4v1.6h.8c.2 0 .3 0 .5-.2l.1-.6-.1-.5c-.1-.2-.3-.3-.5-.3h-.8zm0-.7h.6c.2 0 .4 0 .5-.2l.2-.5-.2-.5-.6-.2h-.5v1.4zM15 7.3c0 .6-.1 1-.4 1.3-.3.3-.7.5-1.3.5-.5 0-1-.2-1.3-.5-.3-.4-.5-.8-.5-1.5V5.5c0-.6.2-1 .5-1.4.3-.3.8-.5 1.3-.5.6 0 1 .1 1.3.4.3.3.4.8.4 1.4h-1l-.1-.7c-.1-.2-.3-.3-.6-.3l-.6.3-.1.8v1.6c0 .4 0 .7.2.9 0 .2.3.2.5.2.3 0 .5 0 .6-.2l.1-.7h1z"}})])])
          )
        }
      }
    